import Cookies from 'js-cookie'
import { addMilliseconds, addYears } from 'date-fns'
import { useRef } from 'react'

export const useGetShowModalDelayTime = (configuration?: Record<string, any>) => {
  const delayMs = parseInt((configuration ?? {}).delay) || 2000
  return useRef(addMilliseconds(new Date(), delayMs))
}

const MAX_NUMBER_OF_MODAL_VIEWS = 3

const getStateManager = (id: string) => {
  const dismissalCookieKey = `dismissed-${id}`
  const submissionCookieKey = `submitted-${id}`
  const viewedCookieKey = `viewed-${id}`

  const getWasModalDismissed = (): boolean => !!Cookies.get(dismissalCookieKey)
  const getNumberOfModalViews = (): number => parseInt(Cookies.get(viewedCookieKey) || '0')
  const getWasModalSubmitted = (): boolean => !!Cookies.get(submissionCookieKey)

  const setModalAsDismissed = (): void =>
    Cookies.set(dismissalCookieKey, '1', { sameSite: 'lax', expires: addYears(new Date(), 20) })

  const setFormAsSubmitted = (): void =>
    Cookies.set(submissionCookieKey, '1', { sameSite: 'lax', expires: addYears(new Date(), 20) })

  const incrementNumberOfModalViews = (): void => {
    const newNumberOfViews = getNumberOfModalViews() + 1
    Cookies.set(viewedCookieKey, newNumberOfViews.toString(), {
      sameSite: 'lax',
      expires: addYears(new Date(), 20),
    })
  }

  /**
   *
   * @returns boolean
   *
   * Can open modal if it wasn't dismissed, wasn't submitted and wasn't shown more then X times
   */
  const getShouldOpenModal = () => {
    const isDismissed = getWasModalDismissed()
    const isSubmitted = getWasModalSubmitted()
    const numberOfModalViews = getNumberOfModalViews()

    return !isDismissed && !isSubmitted && numberOfModalViews <= MAX_NUMBER_OF_MODAL_VIEWS
  }

  return {
    getWasModalDismissed,
    getNumberOfModalViews,
    getWasModalSubmitted,
    getShouldOpenModal,
    setModalAsDismissed,
    setFormAsSubmitted,
    incrementNumberOfModalViews,
  }
}

const VALID_CONTENT_TYPE = 'newExitIntentModal'
const getIsWrongContentType = (data: Record<string, any>) => {
  return (
    !data.references ||
    !data.references[0] ||
    data.references[0].sys.contentType.sys.id !== VALID_CONTENT_TYPE
  )
}

// How many time user has to dismiss modal to not show it again

export const ExitIntentModalService = {
  getStateManager,
  getIsWrongContentType,
  useGetShowModalDelayTime,
}
